export default "__VITE_ASSET__d2dbf229__"